import React, { useMemo, useEffect, useRef } from "react";
import { useMap } from "react-map-gl";
import { useMapboxDraw } from "../../DrawToolProvider";
import { useSelector, useDispatch } from "react-redux";
import { getCornersOfPolygon } from "../ShadeHelpers";
import { ShadeObjectHover } from "../../MapboxFeatureHandlers";

import { canopyActions, getCenterPointofFeature, usePrevious } from "../../../Redux";

const BuildingEventLayer = ({ building, interactive = true }) => {
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const dispatch = useDispatch();
  const draw = useMapboxDraw();

  const selected_shade_object_id = useSelector((state) => state.canopy.selected_shade_object_id);
  const selected_shade_object_id_ref = useRef(selected_shade_object_id);

  const is_measuring = useSelector((state) => state.inputs.uiState.is_measuring);
  const is_measuring_ref = useRef(is_measuring);

  useEffect(() => {
    is_measuring_ref.current = is_measuring;
  }, [is_measuring]);

  useEffect(() => {
    selected_shade_object_id_ref.current = selected_shade_object_id;
  }, [selected_shade_object_id]);

  const memoizedBuilding = useMemo(() => building, [building]);

  // useEffect(() => {
  //   if (selected_shade_object_id && prev_selected_shade_object_id !== selected_shade_object_id) {
  //     if (selected_shade_object_id === memoizedBuilding.id) {
  //       selectFeatureOnMap(selected_shade_object_id);
  //     }
  //   }
  // }, [selected_shade_object_id]);

  useEffect(() => {
    if (!map || !draw || !memoizedBuilding) return;

    const memoizedBuildingWithId = {
      ...memoizedBuilding.geoJson,
      id: memoizedBuilding.id,
      properties: {
        ...memoizedBuilding.geoJson.properties,
        shape: "building",
      },
    };

    draw.add(memoizedBuildingWithId);

    map.once("idle", () => {
      if (selected_shade_object_id_ref.current) {
        selectFeatureOnMap(selected_shade_object_id_ref.current);
      }
    });

    map.on("draw.create", (e) => {
      if (e.features[0].id === memoizedBuilding.id) {
        selectFeatureOnMap(memoizedBuilding.id);
      }
    });

    map.on("draw.update", handleUpdate);
    map.on("draw.delete", handleDelete);

    return () => {
      draw.delete(memoizedBuilding.id);
      map.off("draw.create");
      map.off("draw.update", handleUpdate);
      map.off("draw.delete", handleDelete);
    };
  }, [map, building]);

  const selectFeatureOnMap = (id) => {
    if (!id || !draw.get(id)) return;
    draw.changeMode("direct_select", { featureId: id });
  };

  const handleDelete = (e) => {
    if (e.features[0].properties.shape === "siteFeature" || e.features[0].id === building.id) {
      dispatch(canopyActions.updateShadeObject("delete_shade_object", building.id));
      draw.delete(e.features[0].id);
    }
  };

  const handleUpdate = (e) => {
    if (is_measuring_ref.current) return;
    if (e.features[0].properties.shape === "siteFeature" || selected_shade_object_id_ref.current !== building.id) return;
    // console.log("updating building", e.features[0]);
    let edited_building = { ...memoizedBuilding };
    edited_building.geoJson = e.features[0];
    edited_building.center = getCenterPointofFeature(e.features[0]);
    edited_building.corners = getCornersOfPolygon(e.features[0]);
    edited_building.rotation = 0;
    dispatch(canopyActions.updateShadeObject("edit_shade_object", edited_building));
    draw.delete(e.features[0].id);
  };

  return <ShadeObjectHover obj={memoizedBuilding} />;
};

export { BuildingEventLayer };
